module.exports = __webpack_public_path__ + "img/map.6f09e68a.png";